import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mat-bom",
  "use": "icon-soc-mat-bom-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mat-bom\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"512\" cy=\"256\" r=\"96\" /><circle cx=\"320\" cy=\"480\" r=\"80\" /><circle cx=\"704\" cy=\"480\" r=\"80\" /><circle cx=\"256\" cy=\"736\" r=\"64\" /><circle cx=\"448\" cy=\"736\" r=\"64\" /><path d=\"M512 352v80M320 560v112M400 560v112\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mat-bom.svg
// module id = 2zOJ
// module chunks = 546